export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/xeR1NXPB1P1sRZsMBDs8GJ/WhatsApp_Image_2026-07-31_at_00.04.05.jpg'

export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/cs4DQvA76PgUPc9TWgbCXG/WhatsApp_Image_2026-07-31_at_00.29.29_(2).jpg'

export const TRUST_IMAGES = [
  'https://cdn.magicpatterns.com/uploads/pjbGKQ1A2d3taY58PhQdAo/WhatsApp_Image_2026-08-01_at_12.59.23.jpg',
  'https://cdn.magicpatterns.com/uploads/qHAGpbfrEiFMfcaspkD84e/WhatsApp_Image_2026-08-01_at_12.59.24.jpg',
  'https://cdn.magicpatterns.com/uploads/6tFidzWd2ZJFDR4iP2tnLw/WhatsApp_Image_2026-08-01_at_12.59.23_(1).jpg',
]

export const HOUSECALL_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/bXs42M2xMu6dyXetnSQzr3/WhatsApp_Image_2026-07-31_at_00.29.28.jpg'

export const HOURS_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/v4euAkHepXWwSHrdByzyYo/WhatsApp_Image_2026-07-31_at_00.29.30_(1).jpg'

export const SERVICES_CAROUSEL_IMAGES = [
  'https://cdn.magicpatterns.com/uploads/mtkV9efphEzyMhDe1hsZEt/WhatsApp_Image_2026-07-31_at_00.29.29.jpg',
  'https://cdn.magicpatterns.com/uploads/vCk2YJgrdSpKNyBrhgJdhL/WhatsApp_Image_2026-08-18_at_04.08.18.jpg',
  'https://cdn.magicpatterns.com/uploads/itWhgy8NLE1B5yVCNFG7HT/WhatsApp_Image_2026-08-18_at_04.08.11.jpg',
  'https://cdn.magicpatterns.com/uploads/5dbai5QksQGqyHrUqw6MWd/WhatsApp_Image_2026-08-18_at_04.07.55.jpg',
]

export const NEXT_LEVEL_MEDIA = [
  { type: 'image', src: 'https://cdn.magicpatterns.com/uploads/7Tbvq7AzXBKZj59zn6BZDz/WhatsApp_Image_2026-07-31_at_00.29.30.jpg' },
  { type: 'image', src: 'https://cdn.magicpatterns.com/uploads/wRfaHvnKZJioW4Y9F7uPhF/WhatsApp_Image_2026-07-31_at_00.29.29_(1).jpg' },
  { type: 'video', src: 'https://cdn.magicpatterns.com/uploads/eBAM1CviHTFUiqJgw7HJ8a/WhatsApp%20Video%202026-08-01%20at%2013.16.27.mp4' },
]

export const HOUSECALL_VIDEO_URL =
  'https://cdn.magicpatterns.com/uploads/2qYFm51oSVU4kdUtrcvr72/WhatsApp%20Video%202026-08-18%20at%2004.06.44.mp4'

export const PHONE_DISPLAY = '+34 690 270 220'
export const PHONE_HREF = 'https://wa.me/34690270220'
export const HOUSECALL_WHATSAPP_HREF = 'https://wa.me/34690270220?text=Hola,%20queria%20saber%20mas%20sobre%20la%20experiencia%20vip%20a%20domicilio'
export const INSTAGRAM = '@duvaybarbervip'
export const INSTAGRAM_HREF = 'https://instagram.com/duvaybarbervip'
export const ADDRESS = 'Av. Arias de Velasco 13 · 29601 Marbella'
